window.NotificationActions = class NotificationActions {

  receive(data) {
    if ((window.Notification == null) || (window.Notification.permission !== 'granted')) {
      return
    }

    const options = {
      title: data.title,
      body: data.message,
      icon: 'https://tm2-assets.ams3.cdn.digitaloceanspaces.com/system/images/admin/logo.png',
      tag: data.id,
      requireInteraction: true
    };

    const n = new window.Notification(options.title, options);

    if (data.url) {
      n.onclick = () => window.open(data.url);
    }
  }
};
